import React, { useState } from 'react';
import { MenuProps, MenuItem } from '../../../types/DesignSystem/Menu';
import Typography from '../Typography/Typography';

const Menu: React.FC<MenuProps> = ({
  items,
  onItemClick,
  variant = 'default',
  className = '',
  maxHeight,
}) => {
  const [expandedSubmenu, setExpandedSubmenu] = useState<string | number | null>(null);

  const handleItemClick = (item: MenuItem) => {
    if (!item.disabled) {
      item.onClick?.();
      onItemClick?.(item.id);

      if (item.submenu) {
        setExpandedSubmenu(expandedSubmenu === item.id ? null : item.id);
      }
    }
  };

  const renderMenuItems = (menuItems: MenuItem[], isSubmenu = false) => {
    return menuItems.map((item) => {
      const isExpanded = expandedSubmenu === item.id && item.submenu;

      return (
        <div key={item.id}>
          {item.divider ? (
            <div className="tw-my-1 tw-border-t tw-border-grey-200" />
          ) : (
            <button
              onClick={() => handleItemClick(item)}
              disabled={item.disabled}
              className={`tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-transition-colors ${
                isSubmenu ? 'tw-pl-6' : ''
              } ${
                item.disabled
                  ? 'tw-opacity-50 tw-cursor-not-allowed tw-text-grey-400'
                  : 'hover:tw-bg-grey-50 tw-text-grey-900 tw-cursor-pointer'
              }`}
            >
              {item.icon && <span className="tw-flex-shrink-0">{item.icon}</span>}
              <span className="tw-flex-1">
                <Typography variant="body-primary" className="tw-text-sm">
                  {item.label}
                </Typography>
              </span>
              {item.submenu && (
                <svg
                  className={`tw-w-4 tw-h-4 tw-flex-shrink-0 tw-transition-transform ${
                    isExpanded ? 'tw-rotate-90' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              )}
            </button>
          )}

          {item.submenu && isExpanded && (
            <div className="tw-bg-grey-50">
              {renderMenuItems(item.submenu, true)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div
      className={`tw-bg-white tw-rounded tw-border tw-border-grey-200 tw-overflow-hidden ${className}`}
      style={maxHeight ? { maxHeight, overflowY: 'auto' } : undefined}
    >
      {renderMenuItems(items)}
    </div>
  );
};

export default Menu;
